import { createUseStyles } from 'react-jss';
import type { Theme } from '@wds/styles';

const useStyles = createUseStyles(({ spacing, palette }: Theme) => ({
  wrapper: {
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    padding: '150px 0',
  },
  cardWrapper: {
    marginTop: spacing['4'],
  },
  pageWrapper: {
    backgroundColor: palette.background.main,
  },
}));

export default useStyles;
